<template>
  <div class="auth-wrapper auth-v2">
    <b-row class="auth-inner m-0">

     
      <!-- Sol panel: marka + slogan + ozellik ozeti.
           Yapiyi bozmadan Vuexy auth-v2 sinifi icinde kaliyor; sadece icerik
           genisletildi ve zemin degradesi login-brand-side sinifiyla verildi. -->
      <b-col
        lg="8"
        class="d-none d-lg-flex align-items-center justify-content-center p-5 login-brand-side"
      >
        <div class="brand-content text-center animate__animated animate__fadeIn">
          <b-img
            fluid
            :src="imgUrl"
            alt="Vişne Madencilik"
            class="brand-content__logo mb-3"
          />
          <div class="brand-content__title">Lojistik Yönetim Sistemi</div>
          <div class="brand-content__subtitle mb-3">Vişne Madencilik &middot; Öztüre Holding</div>

          <ul class="brand-content__features list-unstyled">
            <li>
              <feather-icon icon="FileTextIcon" size="18" class="mr-75"/>
              Sözleşme Yönetimi
            </li>
            <li>
              <feather-icon icon="TruckIcon" size="18" class="mr-75"/>
              Sefer Takibi
            </li>
            <li>
              <feather-icon icon="ClipboardIcon" size="18" class="mr-75"/>
              İrsaliye İşlemleri
            </li>
          </ul>
        </div>

        <!-- Alt kose imzasi -->
        <div class="brand-side__footer">
          &copy; {{ new Date().getFullYear() }} Öztüre Holding
        </div>
      </b-col>
      <!-- /Sol panel -->

      <!-- Login-->
      <b-col
        lg="4"
        class="d-flex align-items-center auth-bg px-2 p-lg-5"
      >
        <b-col
          sm="8"
          md="6"
          lg="12"
          class="px-xl-2 mx-auto"
        >
          <b-card-title
            title-tag="h2"
            class="font-weight-bolder mb-25 login-title animate__animated animate__fadeInDown"
          >
            Hoş geldiniz 👋
          </b-card-title>
          <b-card-text class="mb-2 text-muted animate__animated animate__fadeIn">
            Devam etmek için giriş yapınız.
          </b-card-text>

          <!-- form -->
          <validation-observer ref="loginValidation">
            <b-form
              class="auth-login-form mt-2"
              @submit.prevent
            >
              <!-- E-posta: input-group ile mail ikonu; erisilebilirlik icin
                   label-for=login-email korundu. -->
              <b-form-group
                label="E-Posta"
                label-for="login-email"
              >
                <b-input-group class="input-group-merge">
                  <b-input-group-prepend is-text>
                    <feather-icon icon="MailIcon"/>
                  </b-input-group-prepend>
                  <b-form-input
                    id="login-email"
                    v-model="userEmail"
                    name="login-email"
                    class="form-control-merge"
                    placeholder="ornek@sirket.com"
                  />
                </b-input-group>
              </b-form-group>

              <!-- forgot password -->
              <b-form-group>
                <div class="d-flex justify-content-between">
                  <label for="login-password">Parola</label>
                  <b-link :to="{ name:'forgot-password' }">
                    <small>Şifrenizi mi unuttunuz?</small>
                  </b-link>
                </div>
                <validation-provider
                  #default="{ errors }"
                  name="Password"
                  rules="required"
                >
                  <b-input-group
                    class="input-group-merge"
                    :class="errors.length > 0 ? 'is-invalid':null"
                  >
                    <b-input-group-prepend is-text>
                      <feather-icon icon="LockIcon"/>
                    </b-input-group-prepend>
                    <b-form-input
                      id="login-password"
                      v-model="password"
                      :state="errors.length > 0 ? false:null"
                      class="form-control-merge"
                      :type="passwordFieldType"
                      name="login-password"
                      placeholder="············"
                    />
                    <b-input-group-append is-text>
                      <feather-icon
                        class="cursor-pointer"
                        :icon="passwordToggleIcon"
                        @click="togglePasswordVisibility"
                      />
                    </b-input-group-append>
                  </b-input-group>
                  <small class="text-danger">{{ errors[0] }}</small>
                </validation-provider>
              </b-form-group>

              <!-- checkbox -->
              <!-- <b-form-group>
                <b-form-checkbox
                  id="remember-me"
                  v-model="status"
                  name="checkbox-1"
                >
                  Remember Me
                </b-form-checkbox>
              </b-form-group> -->

              <!-- Gonderme -->
              <b-button
                type="submit"
                variant="primary"
                class="d-flex align-items-center justify-content-center login-submit"
                block
                :disabled="loading"
                @click="validationForm"
              >
                <b-spinner small class="mr-50" v-if="loading"></b-spinner>
                Giriş Yap
                <feather-icon v-if="!loading" icon="ArrowRightIcon" size="14" class="ml-50"/>
              </b-button>

              <!-- Kucuk alt bilgi: destek + surum. -->
              <div class="login-support text-center mt-2">
                <small class="text-muted d-block">
                  Hesap sorunları için sistem yöneticisi ile iletişime geçiniz.
                </small>
              </div>
            </b-form>
          </validation-observer>
        </b-col>
      </b-col>
    <!-- /Login-->
    </b-row>
  </div>
</template>

<script>
/* eslint-disable global-require */
import { ValidationProvider, ValidationObserver } from 'vee-validate'
import VuexyLogo from '@core/layouts/components/Logo.vue'
import {
  BRow, BCol, BLink, BFormGroup, BFormInput, BInputGroupPrepend, BInputGroupAppend, BInputGroup, BFormCheckbox, BCardText, BCardTitle, BImg, BForm, BButton, BSpinner
} from 'bootstrap-vue'
import { required, email } from '@validations'
import { togglePasswordVisibility } from '@core/mixins/ui/forms'
import store from '@/store/index'
import { AuthApi } from '@/api/auth'
import Auth from '@/utilities/auth'



export default {
  watch: {
  },
  components: {
    BRow,
    BCol,
    BLink,
    BFormGroup,
    BFormInput,
    BInputGroupPrepend,
    BInputGroupAppend,
    BInputGroup,
    BFormCheckbox,
    BCardText,
    BCardTitle,
    BImg,
    BForm,
    BButton,
    BSpinner,
    VuexyLogo,
    ValidationProvider,
    ValidationObserver,
  },
  mixins: [togglePasswordVisibility],
  data() {
    return {
      status: '',
      password: '',
      userEmail: '',
      sideImg: require('@/assets/images/logo/ozturelogo.png'),
      // validation rulesimport store from '@/store/index'
      required,
      email,
      loading:false,
    }
  },
  computed: {
    passwordToggleIcon() {
      return this.passwordFieldType === 'password' ? 'EyeIcon' : 'EyeOffIcon'
    },
    imgUrl() {
      if (store.state.appConfig.layout.skin === 'dark') {
        // eslint-disable-next-line vue/no-side-effects-in-computed-properties
        this.sideImg = require('@/assets/images/logo/ozturelogo.png')
        return this.sideImg
      }
      return this.sideImg
    },
  },
  methods: {
    validationForm() {
      this.$refs.loginValidation.validate().then(success => {
        if (success) {
          this.loading = true
          AuthApi.Login({
            Email: this.userEmail,
            Password: this.password,
          })
          .then((res)=> {
            this.$result(res)
            this.loading = false
            if(res.data.Success){
              Auth.isAuthenticated = true
              Auth.user = res.data.Data
              // this.$signalr.role.Configure()
              // this.$signalr.notify.Configure()
              // this.$signalr.userActive.Configure()
              
              if(this.$route.query?.redirect){
                this.$router.push(this.$route.query.redirect)
              }else {
                this.$router.push({name:"home"})
              }
            }
          })
          .catch((err)=> {
            this.loading = false
            this.$result(null,err)
          })
        }
      })
    },
  },
}
</script>

<style lang="scss">
@import '@core/scss/vue/pages/page-auth.scss';

/* animate.css'i yalniz bu bilesende kullaniyoruz; global yuk yaratmasin. */
@import '~animate.css/animate.min.css';

/* Marka stili, parola sifirlama ekranlariyla ortak oldugu icin ayri dosyada durur. */
@import '@/assets/scss/auth-brand.scss';
</style>
